var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FeaturesBanner',{staticClass:"black-friday-feature-banner",style:(_vm.featureBannersStyles),attrs:{"items":_vm.featuresBannerItems,"theme":"dark"}})
}
var staticRenderFns = []

export { render, staticRenderFns }